import { render, staticRenderFns } from "./NotificationsSidebar.vue?vue&type=template&id=120cd3ae&scoped=true"
import script from "./NotificationsSidebar.vue?vue&type=script&lang=js"
export * from "./NotificationsSidebar.vue?vue&type=script&lang=js"
import style0 from "./NotificationsSidebar.vue?vue&type=style&index=0&id=120cd3ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120cd3ae",
  null
  
)

export default component.exports